interface HeroSectionProps {
  onInquiryClick: () => void;
  onCategoryClick?: (cat: string) => void;
}

const brandShowcase = [
  {
    brand: 'ATOPALM',
    brandZh: '爱多帕',
    tag: '스킨케어',
    tagZh: '护肤',
    products: [
      'https://neopharmshop.co.kr/web/product/medium/202601/762b6c590127dccf3cd871bfd6c8eef7.jpg',
      'https://neopharmshop.co.kr/web/product/medium/202601/758c4bc5820c9c6b2623b44844076d8e.jpg',
    ],
  },
  {
    brand: 'W.DRESSROOM',
    brandZh: '衣物香水',
    tag: '섬유향수',
    tagZh: '衣物香水',
    products: [
      'https://wdressroom.co.kr/web/product/medium/202309/ecd4d5a5044910e2223256cbea506d90.jpg',
      'https://wdressroom.co.kr/web/product/medium/202309/8bb129f3ff161d2d873cea7eb7bd24d6.jpg',
    ],
  },
  {
    brand: 'HBAF',
    brandZh: '芭蜂坚果',
    tag: '스낵·견과',
    tagZh: '零食·坚果',
    products: [
      'https://i.ibb.co/Tqx6RXWC/1.jpg',
      'https://i.ibb.co/RTmgK4Bf/4.jpg',
    ],
  },
  {
    brand: '두드림',
    brandZh: '韩国汤类',
    tag: '탕류',
    tagZh: '汤类',
    products: [
      'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/a6d48206-c774-4763-a17c-0fe940e1074d_unnamed.png?v=fc0da1a7b3304b1b20a0682b827e364e',
      'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/46e42437-5e59-4e25-85b7-a018b5f45617_unnamed.png?v=6276ced7d9e79cf3ead8afb5c1b8c600',
    ],
  },
  {
    brand: '푸른정',
    brandZh: '福乐正',
    tag: '해조류',
    tagZh: '海藻类',
    products: [
      'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/9726b4de-0c9a-47d7-8512-e42aaf901758_1.jpg?v=96f4687b295052ce8a3965d4a9681ff2',
      'https://storage.readdy-site.link/project_files/566c3b96-85a7-421f-93e5-346f16c9704d/4a506b83-569e-4630-806a-39c8fd9f3da9_3.jpg?v=a0ff645a6b7ac3c18ae98c71360910c6',
    ],
  },
  {
    brand: 'WORLDRUN',
    brandZh: '월드런',
    tag: '운동화',
    tagZh: '运动鞋',
    products: [
      'https://public.readdy.ai/ai/img_res/dd2a420cd2c9de6e0b8e7deae7627c5d.jpg',
      'https://readdy.ai/api/search-image?query=Korean%20professional%20marathon%20running%20shoe%20black%20dark%20colorway%20lightweight%20mesh%20breathable%20carbon%20plate%20sole%20athletic%20performance%20footwear%20side%20view%20white%20background%20clean%20product%20photography&width=300&height=300&seq=hero_wr02&orientation=squarish',
    ],
  },
];

const trustPoints = [
  { icon: 'ri-shield-check-line', ko: '정품 보장', zh: '正品保证' },
  { icon: 'ri-building-2-line', ko: '한국산 직공급', zh: '韩国直供' },
  { icon: 'ri-global-line', ko: '글로벌 대응', zh: '全球对应' },
  { icon: 'ri-time-line', ko: '1일 회신', zh: '1天回复' },
];

export default function HeroSection({ onInquiryClick }: HeroSectionProps) {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (!el) return;
    const bannerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--banner-height') || '0'
    );
    const offset = bannerHeight + 108;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative w-full overflow-hidden"
      style={{
        background: 'linear-gradient(160deg, #162233 0%, #1B2B3A 55%, #1E3247 100%)',
        paddingTop: 'calc(var(--banner-height, 0px) + 108px)',
      }}
    >
      {/* 배경 글로우 */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full opacity-[0.08]"
          style={{ background: 'radial-gradient(circle, #D4A853, transparent 70%)', transform: 'translate(30%, -30%)' }}
        />
        <div
          className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-[0.05]"
          style={{ background: 'radial-gradient(circle, #4A7FA5, transparent 70%)', transform: 'translate(-30%, 30%)' }}
        />
        <div
          className="absolute inset-0 opacity-[0.025]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-5 md:px-10 lg:px-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-14 lg:py-20">

          {/* ── 왼쪽: 텍스트 콘텐츠 ── */}
          <div className="flex-1 w-full text-center lg:text-left">

            {/* 상단 배지 */}
            <div
              className="inline-flex items-center gap-2 mb-7 px-4 py-1.5 rounded-full"
              style={{ background: 'rgba(212,168,83,0.12)', border: '1px solid rgba(212,168,83,0.3)' }}
            >
              <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ backgroundColor: '#D4A853' }} />
              <span className="text-[10px] font-black tracking-[0.22em] uppercase whitespace-nowrap" style={{ color: '#D4A853' }}>
                Korea Premium B2B Catalog
              </span>
            </div>

            {/* 메인 타이틀 */}
            <h1
              className="font-black leading-[1.1] mb-4 text-white"
              style={{
                fontSize: 'clamp(2.1rem, 6vw, 3.8rem)',
                fontFamily: "'Noto Sans KR', sans-serif",
                letterSpacing: '-0.03em',
              }}
            >
              韓国优质商品<br />
              <span style={{ color: '#D4A853' }}>B2B 专业供应</span>
            </h1>

            <p className="font-semibold mb-5" style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.65)', letterSpacing: '0.06em' }}>
              프리미엄 한국 상품 B2B 전문 공급
            </p>

            {/* 골드 구분선 */}
            <div
              className="w-10 h-[2px] mb-7 mx-auto lg:mx-0"
              style={{ background: 'linear-gradient(90deg, #D4A853, transparent)' }}
            />

            {/* 설명 */}
            <p
              className="leading-relaxed mb-8 mx-auto lg:mx-0 max-w-md"
              style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.6)', lineHeight: '1.9', fontFamily: "'Noto Sans KR', sans-serif" }}
            >
              面向网络卖家·团购运营商·批发采购商·企业客户的韩国优质商品B2B专业目录平台。
              <span className="block mt-1 text-[0.8rem] font-medium" style={{ color: 'rgba(255,255,255,0.55)' }}>
                온라인 판매자 · 공동구매 운영자 · 도매 바이어 · 기업 고객을 위한 국내 우수 상품 전문 B2B 카탈로그 플랫폼입니다.
              </span>
            </p>

            {/* 신뢰 포인트 */}
            <div className="grid grid-cols-2 gap-2.5 mb-9 max-w-sm mx-auto lg:mx-0">
              {trustPoints.map(tp => (
                <div
                  key={tp.ko}
                  className="flex items-center gap-2.5 px-3.5 py-3 rounded-xl"
                  style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}
                >
                  <div
                    className="w-7 h-7 flex items-center justify-center rounded-lg shrink-0"
                    style={{ background: 'rgba(212,168,83,0.15)' }}
                  >
                    <i className={`${tp.icon} text-sm`} style={{ color: '#D4A853' }}></i>
                  </div>
                  <div className="min-w-0">
                    <p className="text-[12px] font-bold leading-none text-white whitespace-nowrap">{tp.zh}</p>
                    <p className="text-[10px] font-semibold mt-0.5 whitespace-nowrap" style={{ color: 'rgba(212,168,83,0.8)' }}>{tp.ko}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA 버튼 */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <button
                onClick={() => scrollToSection('recommended')}
                className="px-7 py-3.5 font-black text-[13px] rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
                style={{ background: '#D4A853', color: '#162233' }}
                onMouseEnter={e => (e.currentTarget.style.background = '#E8BC6A')}
                onMouseLeave={e => (e.currentTarget.style.background = '#D4A853')}
              >
                查看全部商品 <span className="font-semibold opacity-80 text-[11px]">/ 전체 상품 보기</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={onInquiryClick}
                className="px-7 py-3.5 font-bold text-[13px] rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-white"
                style={{ border: '1.5px solid rgba(255,255,255,0.25)', background: 'transparent' }}
                onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.08)'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = 'transparent'; }}
              >
                <i className="ri-customer-service-2-line mr-2"></i>
                询价咨询 <span className="font-semibold opacity-80 text-[11px]">/ 상담 문의</span>
              </button>
            </div>

            {/* 통계 */}
            <div
              className="flex items-center gap-8 mt-10 pt-8 justify-center lg:justify-start"
              style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}
            >
              {[
                { num: '11+', label: '카테고리', zh: '分类' },
                { num: '100+', label: '취급 상품', zh: '商品数' },
                { num: '6+', label: '파트너 브랜드', zh: '合作品牌' },
              ].map(s => (
                <div key={s.label} className="text-center lg:text-left">
                  <p className="font-black text-white" style={{ fontSize: '1.5rem', letterSpacing: '-0.02em' }}>{s.num}</p>
                  <p className="text-[10px] mt-0.5" style={{ color: 'rgba(255,255,255,0.6)' }}>{s.zh}</p>
                  <p className="text-[9px] font-semibold" style={{ color: 'rgba(255,255,255,0.45)' }}>{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ── 오른쪽: 브랜드 쇼케이스 ── */}
          <div className="flex-none w-full lg:w-[460px] xl:w-[520px]">

            {/* 섹션 레이블 */}
            <div className="flex items-center justify-between mb-4">
              <p className="text-[10px] font-black tracking-[0.22em] uppercase" style={{ color: 'rgba(212,168,83,0.7)' }}>
                Partner Brands
              </p>
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#D4A853' }} />
                <span className="text-[10px]" style={{ color: 'rgba(255,255,255,0.35)' }}>实际合作品牌 / 실제 취급 브랜드</span>
              </div>
            </div>

            {/* 브랜드 카드 2열 그리드 */}
            <div className="grid grid-cols-2 gap-2.5">
              {brandShowcase.map((brand, i) => (
                <div
                  key={i}
                  className="rounded-xl overflow-hidden"
                  style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)' }}
                >
                  {/* 브랜드 헤더 */}
                  <div
                    className="px-3 py-2 flex items-center justify-between gap-2"
                    style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                  >
                    {/* 브랜드명 + 중국어 */}
                    <div className="min-w-0 flex-1">
                      <p className="font-black text-[11px] text-white leading-tight truncate">{brand.brand}</p>
                      <p className="zh-text text-[9px] font-semibold leading-tight truncate" style={{ color: 'rgba(255,255,255,0.55)' }}>
                        {brand.brandZh}
                      </p>
                    </div>
                    {/* 태그 - 중국어 주 / 한국어 부 */}
                    <div className="flex flex-col items-end shrink-0">
                      <span
                        className="text-[9px] px-1.5 py-0.5 rounded-full font-bold whitespace-nowrap"
                        style={{ background: 'rgba(212,168,83,0.18)', color: '#D4A853' }}
                      >
                        {brand.tagZh}
                      </span>
                      <span
                        className="text-[8px] mt-0.5 whitespace-nowrap"
                        style={{ color: 'rgba(255,255,255,0.35)' }}
                      >
                        {brand.tag}
                      </span>
                    </div>
                  </div>

                  {/* 상품 이미지 2개 */}
                  <div className="grid grid-cols-2">
                    {brand.products.map((img, j) => (
                      <div
                        key={j}
                        className="aspect-square overflow-hidden"
                        style={{ borderRight: j === 0 ? '1px solid rgba(255,255,255,0.07)' : 'none' }}
                      >
                        <img
                          src={img}
                          alt={`${brand.brand} 상품 ${j + 1}`}
                          className="w-full h-full object-cover object-center"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* 신뢰 배너 */}
            <div
              className="mt-3 px-4 py-3.5 rounded-xl flex items-center gap-3"
              style={{ background: 'rgba(212,168,83,0.1)', border: '1px solid rgba(212,168,83,0.25)' }}
            >
              <div className="w-8 h-8 flex items-center justify-center shrink-0">
                <i className="ri-verified-badge-line text-lg" style={{ color: '#D4A853' }}></i>
              </div>
              <div>
                <p className="text-white text-[12px] font-bold whitespace-nowrap">官方合作品牌直接供货</p>
                <p className="text-[10px] font-semibold mt-0.5 whitespace-nowrap" style={{ color: 'rgba(212,168,83,0.85)' }}>
                  공식 파트너 브랜드 직공급 · 正품保证
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
